/**
 * Centralized environment variable access for FunViz.
 * Validates required variables at module load time.
 */

const REQUIRED_VARS = [
  'REACT_APP_BACKEND_URL',
];

/**
 * Validates that all required environment variables are set.
 * Logs a console.warn for each missing variable.
 * @returns {string[]} List of missing variable names.
 */
export function validateEnv() {
  const missing = REQUIRED_VARS.filter(key => !process.env[key]);
  missing.forEach(key => {
    console.warn(`[FunViz] Missing required environment variable: ${key}`);
  });
  return missing;
}

// Run validation at module load time
validateEnv();

export const ENV = {
  BACKEND_URL:  process.env.REACT_APP_BACKEND_URL,
};
